/**
 * 直播 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = "/c-api/";

const index = {
  // 获取用户信息
  userInfo(params) {
    return axios.get("/home/chat/userinfo", { params: params });
  },
  // 消息—红点
  msgIndex(params) {
    return axios.get("/home/msg/index", { params: params });
  },
  // 消息列表（站内/系统）
  msgList(params) {
    return axios.get("/home/msg/list", { params: params });
  },
  // 消息详情（站内/系统）
  msgDetail(params) {
    return axios.get("/home/msg/detail", { params: params });
  },
  // 订单消息
  orderMsg(params) {
    return axios.get("/home/msg/ordermsg", { params: params });
  },
  // 申请直播--匠人
  //   applyLiving (params) {
  //     return axios.post('/home/liveroom/apply', qs.stringify(params))
  //   },
  // 6.和后台客服聊天
  customerchatlist(params) {
    return axios.get("/home/customer-chat/list", { params: params });
  },
  // 7.和后台客服聊天
  customerchatreply(params) {
    return axios.post("/home/customer-chat/reply", qs.stringify(params));
  },
  // 8.添加环信聊天列表
  easemobchantcreate(params) {
    return axios.post('/home/easemobchant/create', qs.stringify(params))
  },
  // 获取环信图片消息
  getimg(params) {
      return axios.post(params.url, qs.stringify(params.data))
  }
  
};

// 导出接口
export default index;
